// extracted by mini-css-extract-plugin
export default {"icon":"NonPersonalizableElements_icon__sMBc9","img":"NonPersonalizableElements_img__ZqYxi","elementContainer":"NonPersonalizableElements_elementContainer__iyi7m"};